/* Maison Thali — vanilla JS */

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-offer]').forEach(initOffer);
  document.querySelectorAll('[data-slider]').forEach(initSlider);
  document.querySelectorAll('[data-vcard]').forEach(initVideoCard);
  document.querySelectorAll('[data-hscroll-root]').forEach(initHScroll);
  initArticleCta();
  initCartDrawer();
});

/* Dans l'éditeur de thème, une section re-rendue perd ses écouteurs : on réarme
   les bandes défilantes et les cards vidéo de la section rechargée. */
document.addEventListener('shopify:section:load', function (e) {
  e.target.querySelectorAll('[data-hscroll-root]').forEach(initHScroll);
  e.target.querySelectorAll('[data-vcard]').forEach(initVideoCard);
});

/* ---- Barre d'achat collante des articles ---- */
function initArticleCta() {
  var bar = document.querySelector('[data-article-cta]');
  if (!bar) return;

  var SHOW_AFTER = 600; // px : on laisse lire le début de l'article avant de solliciter
  var dismissed = sessionStorage.getItem('articleCtaDismissed') === '1';
  var offerVisible = false;

  function update() {
    var show = !dismissed && !offerVisible && window.scrollY > SHOW_AFTER;
    if (show) {
      // On retire `hidden` d'abord, puis on déclenche la classe à la frame suivante :
      // sinon l'élément passe de display:none à sa position finale sans transition.
      bar.hidden = false;
      requestAnimationFrame(function () { bar.classList.add('is-visible'); });
    } else {
      bar.classList.remove('is-visible');
      bar.hidden = true;
    }
  }

  // Quand le bloc offre est à l'écran, la barre n'a plus de raison d'être : le module
  // d'achat complet est déjà sous les yeux du lecteur.
  var offer = document.querySelector('.article__body [data-offer]');
  if (offer && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      offerVisible = entries[0].isIntersecting;
      update();
    }, { threshold: 0 }).observe(offer);
  }

  var close = bar.querySelector('[data-article-cta-close]');
  if (close) {
    close.addEventListener('click', function () {
      dismissed = true;
      sessionStorage.setItem('articleCtaDismissed', '1');
      update();
    });
  }

  window.addEventListener('scroll', update, { passive: true });
  update();
}

/* ---- Défilement horizontal avec flèches + glisser (desktop) ----
   Le swipe tactile marche déjà nativement ; ici on ajoute ce qui manque à la souris. */
function initHScroll(root) {
  var track = root.querySelector('[data-hscroll]');
  if (!track) return;
  var prev = root.querySelector('[data-hscroll-prev]');
  var next = root.querySelector('[data-hscroll-next]');

  function step() {
    var first = track.firstElementChild;
    if (!first) return track.clientWidth;
    var gap = parseFloat(getComputedStyle(track).columnGap || 0) || 0;
    return first.getBoundingClientRect().width + gap;
  }

  function update() {
    // marge de 2px : les largeurs fractionnaires empêchent d'atteindre le max exact
    var max = track.scrollWidth - track.clientWidth;
    root.classList.toggle('is-scrollable', max > 2);
    root.classList.toggle('at-start', track.scrollLeft <= 2);
    root.classList.toggle('at-end', track.scrollLeft >= max - 2);
  }

  if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
  if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });

  /* Glisser à la souris. On ignore le tactile (déjà géré par le navigateur) et on
     n'active le mode « drag » qu'après 4px pour ne pas gêner un simple clic. */
  var down = false, dragging = false, startX = 0, startScroll = 0;
  track.addEventListener('pointerdown', function (e) {
    if (e.pointerType === 'touch' || e.button !== 0) return;
    down = true; dragging = false;
    startX = e.clientX; startScroll = track.scrollLeft;
  });
  track.addEventListener('pointermove', function (e) {
    if (!down) return;
    var dx = e.clientX - startX;
    if (!dragging && Math.abs(dx) < 4) return;
    if (!dragging) { dragging = true; track.classList.add('is-dragging'); }
    e.preventDefault();
    track.scrollLeft = startScroll - dx;
  });
  function endDrag() {
    down = false; dragging = false;
    track.classList.remove('is-dragging');
  }
  track.addEventListener('pointerup', endDrag);
  track.addEventListener('pointercancel', endDrag);
  track.addEventListener('pointerleave', endDrag);
  track.addEventListener('dragstart', function (e) { if (dragging) e.preventDefault(); });

  track.addEventListener('scroll', update);
  window.addEventListener('resize', update);
  update();
}

/* ---- Slider images produit ---- */
function initSlider(root) {
  var track = root.querySelector('[data-slides]');
  var slides = root.querySelectorAll('.offer__slide');
  // La bande de miniatures est hors de .offer__slider (sœur dans .offer__media)
  var scope = root.parentElement || root;
  var thumbsWrap = scope.querySelector('[data-slider-thumbs]');
  var thumbs = thumbsWrap ? Array.prototype.slice.call(thumbsWrap.querySelectorAll('[data-thumb]')) : [];
  if (!track || slides.length < 2) return;

  function index() {
    return Math.round(track.scrollLeft / track.clientWidth);
  }
  function goTo(i) {
    i = Math.max(0, Math.min(slides.length - 1, i));
    track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
  }
  function update() {
    var i = index();
    thumbs.forEach(function (t, k) {
      var active = k === i;
      t.classList.toggle('is-active', active);
      t.setAttribute('aria-current', active ? 'true' : 'false');
    });
    // garde la miniature active centrée dans la bande horizontale
    if (thumbsWrap && thumbs[i]) {
      var el = thumbs[i];
      var target = el.offsetLeft - (thumbsWrap.clientWidth - el.offsetWidth) / 2;
      thumbsWrap.scrollTo({ left: Math.max(0, target), behavior: 'smooth' });
    }
  }

  thumbs.forEach(function (t, i) {
    t.addEventListener('click', function () { goTo(i); });
  });

  var prev = root.querySelector('[data-slider-prev]');
  var next = root.querySelector('[data-slider-next]');
  if (prev) prev.addEventListener('click', function () { goTo(index() - 1); });
  if (next) next.addEventListener('click', function () { goTo(index() + 1); });

  var t;
  track.addEventListener('scroll', function () {
    clearTimeout(t); t = setTimeout(update, 80);
  });
  update();
}

function initOffer(root) {
  // Toutes les cards, achat unique compris (.plan--one, data-mode="one" sans
  // selling plan) : un seul groupe radio, un seul bouton « Acheter maintenant ».
  var cards = root.querySelectorAll('.plan');
  var subWrap = root.querySelector('[data-sub-wrap]');
  // Mise en page classique : le prix affiché en haut de colonne suit la formule
  // choisie, sinon il contredirait la card sélectionnée juste en dessous.
  var priceEl = root.querySelector('[data-offer-price]');
  var form = root.querySelector('.offer-form');
  var variantInput = form ? form.querySelector('[name="id"]') : null;
  var planInput = form ? form.querySelector('[name="selling_plan"]') : null;
  var qtyInput = form ? form.querySelector('[name="quantity"]') : null;

  function select(card) {
    cards.forEach(function (c) {
      c.classList.remove('plan--selected');
      c.setAttribute('aria-checked', 'false');
    });
    card.classList.add('plan--selected');
    card.setAttribute('aria-checked', 'true');

    var mode = card.dataset.mode;
    // Encadré abonnement : grisé quand achat unique
    if (subWrap) subWrap.classList.toggle('sub-wrap--off', mode !== 'sub');

    sync(card);
  }

  function sync(card) {
    if (priceEl) {
      var cardPrice = card.querySelector('.plan__price');
      if (cardPrice) priceEl.innerHTML = cardPrice.innerHTML;
    }
    if (variantInput) variantInput.value = card.dataset.variantId || '';
    if (qtyInput) qtyInput.value = card.dataset.qty || '1';
    if (planInput) {
      var planId = card.dataset.sellingPlanId || '';
      planInput.value = planId;
      planInput.disabled = !planId; // un selling_plan vide casse /cart/add
    }
    // Libellé personnalisé pour le panier (line item property cachée : _cart_label)
    if (form) {
      setHiddenProp(form, '_cart_label', card.dataset.cartLabel || '');
      // Nombre de boîtes par abonnement (>1 uniquement) : permet au panier d'afficher
      // un nombre d'ABONNEMENTS et de stepper le +/- par paquet de boîtes.
      var units = (card.dataset.mode === 'sub') ? (card.dataset.subUnits || card.dataset.qty || '1') : '';
      if (parseInt(units, 10) > 1) {
        setHiddenProp(form, '_sub_units', units);
      } else {
        setHiddenProp(form, '_sub_units', '');
      }
    }
  }

  // Crée/maj/désactive un input caché properties[name]. Valeur vide => désactivé (non envoyé).
  function setHiddenProp(form, name, value) {
    var input = form.querySelector('input[name="properties[' + name + ']"]');
    if (value) {
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'properties[' + name + ']';
        form.appendChild(input);
      }
      input.value = value;
      input.disabled = false;
    } else if (input) {
      input.disabled = true;
    }
  }

  cards.forEach(function (c) {
    c.addEventListener('click', function () { select(c); });
  });

  // init : première card "plan--selected" (sinon première card de la liste)
  var first = root.querySelector('.plan--selected') || cards[0];
  if (first) select(first);
}


/* ---- Carte vidéo : play/pause au clic ---- */
function initVideoCard(card) {
  var video = card.querySelector('[data-video]');
  var btn = card.querySelector('[data-vplay]');
  if (!video) return;
  video.controls = false; // jamais de player natif
  function toggle() {
    if (video.paused) {
      // pause les autres vidéos en cours
      document.querySelectorAll('[data-video]').forEach(function (v) {
        if (v !== video && !v.paused) v.pause();
      });
      video.play();
      card.classList.add('is-playing');
    } else {
      video.pause();
      card.classList.remove('is-playing');
    }
  }
  if (btn) btn.addEventListener('click', toggle);
  // clic sur la vidéo elle-même = pause/play
  video.addEventListener('click', toggle);
  video.addEventListener('pause', function () { card.classList.remove('is-playing'); });
  video.addEventListener('ended', function () { card.classList.remove('is-playing'); });
}


/* ==========================================================
   PANIER — drawer sidebar, AJAX add to cart
   ========================================================== */
function initCartDrawer() {
  var drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;

  var itemsEl = drawer.querySelector('[data-cart-items]');
  var giftsEl = drawer.querySelector('[data-cart-gifts]');
  var emptyEl = drawer.querySelector('[data-cart-empty]');
  var subtotalEl = drawer.querySelector('[data-cart-subtotal]');
  var shipEl = drawer.querySelector('[data-cart-shipping]');
  var grandEl = drawer.querySelector('[data-cart-grand]');
  var progressEl = drawer.querySelector('[data-cart-progress]');
  var progressMsg = drawer.querySelector('[data-progress-msg]');
  var progressFill = drawer.querySelector('[data-progress-fill]');
  var msGift = drawer.querySelector('[data-ms-gift]');
  var msShip = drawer.querySelector('[data-ms-ship]');
  var discountForm = drawer.querySelector('[data-discount-form]');
  var discountMsg = drawer.querySelector('[data-discount-msg]');
  var checkoutBtn = drawer.querySelector('[data-cart-checkout]');
  var discountRow = drawer.querySelector('[data-cart-discount-row]');
  var discountAmountEl = drawer.querySelector('[data-cart-discount-amount]');
  // Remise automatique de lancement (réglage thème « Promotion », en %).
  // Facturée par la réduction automatique Shopify ; ici on reflète le prix final.
  var promoRate = parseInt(drawer.getAttribute('data-promo-rate'), 10) || 0;

  // Cadeau feel good : offert sans minimum d'achat (repère sans montant, acquis dès
  // qu'il y a un article). Seul le seuil de livraison offerte fait progresser la barre.
  var FREE_SHIP_THRESHOLD = 5500; // 55 € : livraison offerte (tarif Shopify « dès 55 € »)
  var BAR_MAX = 6570; // la barre est pleine au prix de la cure 3 mois (65,70 €)
  // Repères de cart-drawer.liquid sur cette échelle : cadeau à 0 %, livraison à 100 %.

  function open() {
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function close() {
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  drawer.querySelectorAll('[data-cart-close]').forEach(function (b) {
    b.addEventListener('click', close);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });

  function formatMoney(cents) {
    var n = (cents / 100).toFixed(2).replace('.', ',');
    return n + ' €';
  }

  /* Prix affiché d'une ligne. Si Shopify a déjà déduit la remise dans /cart.js
     (réduction automatique « sur des produits » : final < original), on reprend
     ses montants. Sinon (réduction « sur la commande », invisible en AJAX), on
     applique promoRate nous-mêmes. floor = même arrondi que le Liquid des cards. */
  function linePrices(item) {
    var original = item.original_line_price;
    var final = item.final_line_price;
    if (final < original) return { compare: original, price: final };
    if (promoRate > 0 && !item.selling_plan_allocation) return { compare: original, price: Math.floor(original * (100 - promoRate) / 100) };
    return { compare: 0, price: final };
  }

  /* Totaux affichés : somme des lignes avant / après remise */
  function displayTotals(cart) {
    var original = 0, discounted = 0;
    (cart.items || []).forEach(function (item) {
      var p = linePrices(item);
      original += p.compare || p.price;
      discounted += p.price;
    });
        if (cart.total_price < discounted) discounted = cart.total_price;
    return { original: original, discounted: discounted, saved: original - discounted };
  }

  /* Pastille de quantité du header. On compte comme le tiroir : une formule
     multi-boîtes vaut 1 et non son nombre de boîtes (cf. perUnit dans render),
     sinon l'abonnement 3 mois afficherait 3 alors que le tiroir montre 1. */
  function updateCount(cart) {
    var n = (cart.items || []).reduce(function (sum, item) {
      var per = (item.properties && parseInt(item.properties._sub_units, 10)) || 1;
      if (per < 1) per = 1;
      return sum + Math.max(1, Math.round(item.quantity / per));
    }, 0);
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = n > 99 ? '99+' : n;
      el.hidden = n === 0;
    });
  }

  function render(cart) {
    if (!cart) return;
    updateCount(cart);
    itemsEl.innerHTML = '';
    if (giftsEl) giftsEl.hidden = cart.item_count === 0;
    if (cart.item_count === 0) {
      emptyEl.hidden = false;
      checkoutBtn.style.display = 'none';
    } else {
      emptyEl.hidden = true;
      checkoutBtn.style.display = '';
      cart.items.forEach(function (item) {
        var li = document.createElement('li');
        li.className = 'cart-line';
        li.dataset.key = item.key;
        var cartLabel = item.properties && item.properties._cart_label;
        var titleHtml = cartLabel ? cartLabel : item.product_title;
        if (!cartLabel && item.selling_plan_allocation) {
          titleHtml += ' — <em>' + item.selling_plan_allocation.selling_plan.name + '</em>';
        }
        // Abonnement multi-boîtes : 1 « unité affichée » = perUnit boîtes.
        // Le panier montre le nombre d'abonnements et le +/- agit par paquet de perUnit.
        var perUnit = (item.properties && parseInt(item.properties._sub_units, 10)) || 1;
        if (perUnit < 1) perUnit = 1;
        var displayQty = Math.max(1, Math.round(item.quantity / perUnit));
        // variant_title peut être "Default Title" : on le masque dans ce cas
        var variantLine = (item.variant_title && item.variant_title !== 'Default Title')
          ? '<p class="cart-line__variant">' + item.variant_title + '</p>' : '';
        var prices = linePrices(item);
        li.innerHTML =
          '<img class="cart-line__img" src="' + (item.image || '') + '" alt="">' +
          '<div class="cart-line__main">' +
            '<p class="cart-line__title">' + titleHtml + '</p>' +
            variantLine +
            '<div class="cart-line__qty">' +
              '<button type="button" data-qty="-1" aria-label="Réduire la quantité">−</button>' +
              '<span>' + displayQty + '</span>' +
              '<button type="button" data-qty="+1" aria-label="Augmenter la quantité">+</button>' +
              '<button type="button" class="cart-line__remove" data-remove aria-label="Retirer">Retirer</button>' +
            '</div>' +
          '</div>' +
          '<p class="cart-line__price">' +
            (prices.compare ? '<s class="cart-line__compare">' + formatMoney(prices.compare) + '</s> ' : '') +
            formatMoney(prices.price) +
          '</p>';
        // listeners : on incrémente par paquet de perUnit boîtes (= 1 abonnement)
        li.querySelectorAll('[data-qty]').forEach(function (b) {
          b.addEventListener('click', function () {
            var step = parseInt(b.dataset.qty, 10) * perUnit;
            updateQty(item.key, item.quantity + step);
          });
        });
        li.querySelector('[data-remove]').addEventListener('click', function () {
          updateQty(item.key, 0);
        });
        itemsEl.appendChild(li);
      });
    }
    var totals = displayTotals(cart);
    subtotalEl.textContent = formatMoney(totals.original);
   if (discountRow) {
  var promoIncluded = promoRate > 0 && (cart.items || []).some(function (item) {
    return !!item.selling_plan_allocation;
  });

  var showDiscount = totals.saved > 0 || promoIncluded;
  discountRow.hidden = !showDiscount;
  discountRow.style.display = showDiscount ? '' : 'none';

  if (discountAmountEl) {
    discountAmountEl.textContent = totals.saved > 0
      ? '−' + formatMoney(totals.saved)
      : 'Déjà incluse';
  }
}
    // Seuil de livraison offerte et total : sur le montant réellement payé,
    // comme Shopify les évalue au checkout après remise.
    updateProgress(cart, totals.discounted);
    updateShipping(cart, totals.discounted);
  }

  /* Barre de progression : livraison offerte dès 55 €, puis 2 cadeaux.
     Les cadeaux sont réservés à la cure 3 mois : ils ne se débloquent pas au
     montant mais à la présence d'un abonnement de 3 boîtes ou plus. */
  function hasThreeMonthCure(cart) {
    return (cart.items || []).some(function (item) {
      var units = (item.properties && parseInt(item.properties._sub_units, 10)) || 1;
      return !!item.selling_plan_allocation && units >= 3;
    });
  }
  function updateProgress(cart, s) {
    if (!progressEl) return;
    if (cart.item_count === 0) { progressEl.hidden = true; return; }
    progressEl.hidden = false;
    var cure3 = hasThreeMonthCure(cart);
    var shipOk = cure3 || s >= FREE_SHIP_THRESHOLD;
    // Sans cure 3 mois, la barre s'arrête au repère livraison : un gros panier
    // en achat unique ne doit pas laisser croire que les cadeaux sont acquis.
    var fill = cure3 ? 1 : Math.min(s, FREE_SHIP_THRESHOLD) / BAR_MAX;
    progressFill.style.width = Math.min(fill, 1) * 100 + '%';
    var msg;
    if (cure3) {
      msg = '🎁 Livraison offerte et <b>2 cadeaux</b> débloqués avec ta cure 3 mois';
    } else if (shipOk) {
      msg = '🚚 Livraison offerte ! Passe à la <b>cure 3 mois</b> pour débloquer tes 2 cadeaux';
    } else {
      msg = 'Plus que <b>' + formatMoney(FREE_SHIP_THRESHOLD - s) + '</b> pour la livraison offerte · la cure 3 mois t\'offre aussi 2 cadeaux';
    }
    progressMsg.innerHTML = msg;
    if (msShip) msShip.classList.toggle('is-reached', shipOk);
    if (msGift) msGift.classList.toggle('is-reached', cure3);
  }

  /* Livraison affichée directement à partir des tarifs fixes de la boutique
     (Expédition et livraison) : offerte dès 55 € ou avec la cure 3 mois, sinon
     0,50 €. Plus d'appel à /cart/shipping_rates.json, qui échouait souvent et
     laissait « Calculée au paiement ». À mettre à jour si les tarifs changent. */
  var SHIP_PRICE = 50; // 0,50 €
  function updateShipping(cart, s) {
    if (!shipEl || !grandEl) return;
    if (cart.item_count === 0) { shipEl.textContent = '—'; grandEl.textContent = formatMoney(0); return; }
    var free = hasThreeMonthCure(cart) || s >= FREE_SHIP_THRESHOLD;
    applyShipping(s, free ? 0 : SHIP_PRICE);
  }
  function applyShipping(subtotal, cents) {
    shipEl.textContent = cents === 0 ? 'Offerte' : formatMoney(cents);
    grandEl.textContent = formatMoney(subtotal + cents);
  }

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); });
  }
  function updateQty(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(render);
  }

  /* ---- Code promo (Shopify v2: applique via /discount/CODE) ---- */
  if (discountForm) {
    discountForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var code = discountForm.querySelector('input[name="discount"]').value.trim();
      if (!code) return;
      discountMsg.textContent = 'Application…';
      // /discount/CODE active la promo en session et redirige : on l'appelle silencieusement
      fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' })
        .then(function () { return fetchCart(); })
        .then(function (cart) {
          render(cart);
          discountMsg.textContent = 'Code « ' + code + ' » appliqué. Réduction visible au paiement.';
          discountMsg.dataset.state = 'ok';
        })
        .catch(function () {
          discountMsg.textContent = 'Impossible d\'appliquer ce code.';
          discountMsg.dataset.state = 'err';
        });
    });
  }

  /* ---- Intercepte tous les formulaires d'ajout au panier ---- */
  document.querySelectorAll('form[action$="/cart/add"]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      if (btn) btn.disabled = true;
      var fd = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        body: fd,
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json' }
      })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (err) { throw err; });
        return r.json();
      })
      .then(function () { return fetchCart(); })
      .then(function (cart) {
        render(cart);
        open();
      })
      .catch(function (err) {
        alert((err && err.description) || 'Impossible d\'ajouter au panier.');
      })
      .finally(function () { if (btn) btn.disabled = false; });
    });
  });

  // Pré-remplit le drawer au chargement (utile si le visiteur a déjà un panier)
  fetchCart().then(render);

  // Ouvrir le drawer depuis n'importe quel lien #cart
  document.querySelectorAll('[href="#cart"], [data-cart-open]').forEach(function (a) {
    a.addEventListener('click', function (e) { e.preventDefault(); open(); });
  });
}
